import * as o from "react";
import a from "../lib/SSRBase.es.js";
import m from "../defs/XLogo.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "XLogoIcon";
const f = e;
export {
  f as XLogo,
  e as XLogoIcon
};
